import React from 'react'
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox, CheckboxIcon } from './Checkbox.styles'

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  color?: 'green' | 'red'
  label?: React.ReactNode
  width?: number | string
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  color = 'green',
  label,
  disabled,
  width,
  ...props
}) => (
  <CheckboxContainer $color={color} disabled={disabled}>
    <HiddenCheckbox checked={checked} onChange={onChange} disabled={disabled} {...props} />
    <StyledCheckbox checked={checked} $color={color} disabled={disabled} $width={width}>
      {checked && <CheckboxIcon $color={color}>{color === 'red' ? '✗' : '✓'}</CheckboxIcon>}
    </StyledCheckbox>
    {label && <span style={{ marginLeft: 8 }}>{label}</span>}
  </CheckboxContainer>
)
